
export class DeleteAclrrINModel { 
    idAclrr: number
}